import { APICallV3Put } from 'reactApp/api/APICall';

export class UploadResumableCheckAPICall extends APICallV3Put {
    _method = '';
    _withCredentials = true;
}
